import React from 'react'
import PropTypes from 'prop-types'

export const PayerInfo = (props) => {

    const {empPerson} = props;

    return (
        <div>
            <h4>
                <strong>{empPerson.fantasyName ? empPerson.fantasyName : empPerson.name}</strong>
            </h4>
            <br/><span style={{fontSize: 14}}>{empPerson.name}</span>
            <br/><span style={{fontSize: 14}}>{empPerson.email}</span>
            <br/><span style={{fontSize: 14}}>{empPerson.phoneOne}</span>
        </div>
    )
}

PayerInfo.PropTypes = {
    empPerson: PropTypes.object.isRequired
}

export default PayerInfo


// WEBPACK FOOTER //
// ./src/components/BankBillet/PayerInfo.js